//import packages
import React, { useEffect, useState, useRef } from "react";
import { useRouteMatch, useHistory } from "react-router-dom";
import { CustomDropdown } from "../../utils/resuableComponents/CustomDropdown";
import CustomTextField from "../../utils/resuableComponents/CustomTextfield";
import { getStateList, getCityList, getStoreAmenities, servicesList } from "../../services/apiServices/GetServices";
import { GetCityList, updateStoreDetails, createStoreDetails, getPresignedUrl } from "../../services/apiServices/PostServices";
import { useForm } from "react-hook-form";
import { Formik, useFormik } from 'formik';
import dayjs from "dayjs";


//component import 
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { DesktopTimePicker } from '@mui/x-date-pickers/DesktopTimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import FileUpload from "../../utils/resuableComponents/FileUpload";
import CustomModal from "../../utils/resuableComponents/CustomModal";
import { showToast } from "../../utils/constants/Toaster";
import { ImageUtils } from "../../utils/imageUtils/ImageUtils";
import { holidaysData } from "../../utils/TextInputUtils";
import Loader from "../loadingScreens/Loader";


const AddStoresForms = (props) => {

    const history = useHistory();
    const [statesData, setStatesData] = useState([])
    const [cityData, setCityData] = useState([])
    const [stateId, setStateId] = useState("")
    const [storeAmenitiesData, setStoreAmenitiesData] = useState([])
    const [servicesData, setServicesData] = useState([])
    const [disableSubmit, setDisableSubmit] = useState(false)
    const [disableDraft, setDisableDraft] = useState(false)
    const [isLoader,setIsLoader]=useState(false)
    const storeId = props?.location?.state?.storeDetails?.id
    const storeDetails = props?.location?.state?.storeDetails
    const isPublished = props?.location?.state?.isPublished
  
    const  formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }

    const [errorMessage, setErrorMessage] = useState("")
    const [errorBannerMessage,setBannerErrorMessage]=useState("")
    const [initialValues, setInitialValues] = useState({
        storeName: storeDetails?.name || '',
        storeCategory: storeDetails?.type || '',
        email: storeDetails?.email || '',
        address: storeDetails?.address || '',
        holiday: storeDetails?.holidays || "",
        state: storeDetails?.state || '',
        city: storeDetails?.city || '',
        openTime: storeDetails?.open_time || '',
        closeTime: storeDetails?.close_time || '',
        launchDate : storeDetails?.launch_date|| '',
        aboutStore: storeDetails?.description || '',
        userType: storeDetails?.type || '',
        phoneNumber: storeDetails?.phone_number || '',
        thumbnailImg: storeDetails?.thumbnail_url || [],
        bannerImg : storeDetails?.banner_url || [],
        latitude: storeDetails?.latitude || "",
        longitude: storeDetails?.longitude || "",
        signedthumbnailImg: storeDetails !== undefined ? [storeDetails?.thumbnail_url] : [],
        signedBannerImg : storeDetails !== undefined ? [storeDetails?.banner_url] :[],
        displayImg: storeDetails !== undefined ? storeDetails?.image_url.split(",") : [],
        signedDisplayImg: storeDetails !== undefined ? storeDetails?.image_url.split(",") : [],
        amenitieschecked: storeDetails?.amenities.split(",") || '',
        googleReviewLink: storeDetails?.review_url || '',
        isPublished: 1
    });
    const [checkedValues, setCheckedValues] = useState([])
    const [holidaysChecked, setHolidaysChecked] = useState([])
    const [show, setShow] = useState(false);
    const [bannerShow,setBannerShow]=useState(false);
    const [previewImg, setPreviewImg] = useState("");
    const [bannerViewImg,setBannerViewImg]=useState( storeDetails?.banner_url ||  "")
    const [displayedArrayImages, setDisplayedArrayImages] = useState( storeDetails?.image_url === "" ? [] : storeDetails?.image_url.split(",")  || [])
    const googleMapKey = process.env.React_APP_Google_Api_Key
     

    const handleClose = () => setShow(false);

    const handleBannerClose = () => setBannerShow(false)


    const isToday = (date) => {
        const today = new Date();
        return (
            date.getFullYear() === today.getFullYear() &&
            date.getMonth() === today.getMonth() &&
            date.getDate() === today.getDate()
        );
    }

    const  isPastDate = (date) => { 
        const pastDate = new Date(date)
        const currentDate = new Date();
        if(isToday(pastDate) ){
            return false;
        }else {
            return pastDate < currentDate
        }
    }
    
    const  isFutureDate = (date) =>  {
        const futureDate = new Date(date)
        const currentDate = new Date();
        if(isToday(futureDate) ){
            return false;
        }else {
            return futureDate > currentDate;
        } 
    }

    useEffect(() => {
        callStateslistApi()
        getStoreAmenitiesApi()
        callServicesApi()
    }, []);

    useEffect(() => {
        if (stateId != "" || storeDetails?.state != undefined) {
            callCitylistApi()
        }
    }, [stateId]);

    useEffect(() => {
        if (storeDetails !== undefined) {
            const selectedCheckbox = storeDetails?.amenities.split(",")
            const amenitiesArray = selectedCheckbox.filter((item) => { return item !== "," })
            setCheckedValues(amenitiesArray)
            const holidayArrayData = storeDetails?.holidays.split(",")
            const holidaysArray = holidayArrayData.filter((item) => { return item })
            setHolidaysChecked(holidaysArray)
        }
    }, []);

    useEffect(() => {
        // Check if the Google Maps API script has already been loaded
        if (!window.google) {
            // Load the Google Maps JavaScript API script dynamically
            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${googleMapKey}&callback=initMap`;
            script.async = true;
            script.defer = true; // Add defer attribute to ensure script execution order
            window.initMap = initMap; // Function to initialize the map
            script.onerror = () => {
                console.error('Error loading Google Maps API script.');
            };
            document.body.appendChild(script);
        } else {
            // If the Google Maps API script is already loaded, initialize the map immediately
            initMap();
        }
    }, []);
    
     async function initMap() {
        try {
            const map = new window.google.maps.Map(document.getElementById('map'), {
                center: { lat: 13.003554191501909, lng: 77.58905410766602 },
                zoom: 3
            });
            
            let latitudeVal = parseFloat(storeDetails?.latitude)
            let longitudeVal = parseFloat(storeDetails?.longitude)
    
            const myLatLng = { lat: latitudeVal, lng: longitudeVal };
    
            const advancedMarker = new window.google.maps.Marker({
                position: myLatLng,
                map,
                title: "",
                advanced:true,
            });
        
    
            // Add event listener to capture user click on the map
            map.addListener('click', (event) => {
                // Retrieve latitude and longitude of the clicked location
                const lat = event.latLng.lat();
                const lng = event.latLng.lng();
                formik.setValues(prevValues => ({
                    ...prevValues,
                    latitude: lat,
                }));
                formik.setValues(prevValues => ({
                    ...prevValues,
                    longitude: lng,
                }));
                // fetchPlaceId()
            });
        } catch(error) {
            console.error('Error initializing Google Maps:', error);
        }   
    }
    

    const handlePreviewImg = (data) => {
        setPreviewImg(data)
        setShow(true)
    }

    const handleBannerPreview = (data)=> {
        setBannerViewImg(data)
        setBannerShow(true)
    }

    //function to call list api
    const callStateslistApi = async () => {
        try{
            const res = await getStateList("state/1")
            if (res?.success) {
                setStatesData(res?.data)
            } else {
                console.log("res", res?.message)
            }
        }catch(error){
            console.log(error)
        }
       
    }

    //function to call list api
    const callServicesApi = async () => {
        try{
            const res = await servicesList("services")
            if (res?.success) {
                setServicesData(res?.data)
            } else {
                console.log("res", res?.message)
            }
        }catch(error){
            console.log(error)
        }
       
    }

    //function to call Store Amenities
    const getStoreAmenitiesApi = async () => {
        try{
        const res = await getStoreAmenities("store_amenities")
            if (res?.success) {
                setStoreAmenitiesData(res?.data)
            } else {
                console.log("res", res?.message)
            }
        }catch(error){
            console.log(error)
        }
    }

    //function to call city api
    const callCitylistApi = async () => {
        try{
            const reqbody = {
                state_id: stateId || storeDetails?.state
            }
            const res = await GetCityList(`city`, reqbody)
            if (res?.success) {
                const citiesWithOthers = [...res?.data, { id: 'others', name: 'Others' }];
                setCityData(citiesWithOthers)
            } else {
                console.log("res", res?.message)
            }
        }catch(error){
            console.log(error)
        }
       
    }

    //function to handle on click of space submit
    const handleKeyDown = (event) => {
        // Check if the pressed key is the space key and if the submit button is focused
        if (event.key === ' ' || event.key === 'Spacebar') {
            const submitButton = document.activeElement;
            if (submitButton && submitButton.type === 'submit') {
                // Prevent the default action (form submission) when the space key is pressed
                event.preventDefault();
            }
        }
    };

    const handleStoreName = event => {
        let val = event
        if (event.includes('/')) {
            // If slash is present, update the input value without the slash
            val = event.replace('/', '');
          } else {
            // Otherwise, update the input value normally
           val = event
          }
        formik.setValues(prevValues => ({
            ...prevValues,
            storeName: val,
        }));

    };

    const handleNumberChange = event => {
        // const number = event;
        let phoneNumber = event;
        if (phoneNumber.startsWith('0')) {
            phoneNumber = ""
        } else {
            phoneNumber = phoneNumber
        }
        formik.setValues(prevValues => ({
            ...prevValues,
            phoneNumber: phoneNumber,
        }));
    };

    const handleEmailChange = event => {
        const newEmail = event;
        formik.setValues(prevValues => ({
            ...prevValues,
            email: newEmail,
        }));
    };

    const handleOpenTime = event => {
        const openTime = event;
        formik.setValues(prevValues => ({
            ...prevValues,
            openTime: openTime,
        }));
    };

    const handleCloseTime = event => {
        const closeTime = event;
        formik.setValues(prevValues => ({
            ...prevValues,
            closeTime: closeTime,
        }));
    };

    const handleLaunchTime = event => {
        const launchDate = new Date(event);
        formik.setValues(prevValues => ({
            ...prevValues,
            launchDate: formatDate(launchDate),
        }));
    }

    const handleAboutStoreChange = event => {
         const newInputValue = event;
    formik.setValues(prevValues => ({
        ...prevValues,
        aboutStore: newInputValue,
    }));
    };

    const handleOnchangeAddress = event => {
        const address = event;
        formik.setValues(prevValues => ({
            ...prevValues,
            address: address,
        }));
    };

    const handleStateChange = event => {
        const state = event.target.value;
        setStateId(state?.id)
        setCityData([])
        formik.setValues(prevValues => ({
            ...prevValues,
            state: state?.id,
            city: ""
        }));
    };

    const handleStoreCategory = event => {
        const storeCategory = event.target.value;
        formik.setValues(prevValues => ({
            ...prevValues,
            storeCategory: storeCategory?.id,
        }));
    };

    const handleCityChange = event => {
        const city = event.target.value;
        formik.setValues(prevValues => ({
            ...prevValues,
            city: city?.id,
        }));
    };

    //function to handleCheckBox
    const handleChangeCheckbox = (e, id) => {
        let newSelectedIds = [...checkedValues || []]
        if (e.target.checked) {
            // Add the ID to the array if checked
            newSelectedIds = [...newSelectedIds, id.toString()];
        } else {
            // Remove the ID from the array if unchecked
            newSelectedIds = newSelectedIds.filter((selectedId) => selectedId.toString() !== id.toString());
        }
        setCheckedValues(newSelectedIds)
        formik.setValues(prevValues => ({
            ...prevValues,
            amenitieschecked: newSelectedIds,
        }));
    }

    //function to handleCheckBox
    const handleHolidayCheckbox = (e, id) => {
        let newHolidayIds = [...holidaysChecked || []]
        if (e.target.checked) {
            // Add the ID to the array if checked
            newHolidayIds = []
                = [...holidaysChecked, id.toString()];
        } else {
            // Remove the ID from the array if unchecked
            newHolidayIds = holidaysChecked.filter((selectedId) => selectedId.toString() !== id.toString());
        }
        setHolidaysChecked(newHolidayIds)
        formik.setValues(prevValues => ({
            ...prevValues,
            holiday: newHolidayIds,
        }));
    }

    const handleGoogleReviewLink = (e) => {
        const reviewLink = e
        formik.setValues(prevValues => ({
            ...prevValues,
            googleReviewLink: reviewLink,
        }));
    }

    const {
        handleSubmit,
        setValue,
        control,
        formState: { errors },
    } = useForm({
        // defaultValues: {
        //     checkbox: false,
        // },
    });

    const handleAddStoreApi = async (values) => {
        setDisableSubmit(true)
        setIsLoader(true)
        const reqBody = {
            id: storeId != undefined ? storeId : "",
            type: values?.storeCategory || storeDetails?.type,
            state: values?.state || storeDetails?.state,
            city: values?.city || storeDetails?.city,
            store_name: values?.storeName.trimEnd(),
            open_time: values?.openTime,
            close_time: values?.closeTime,
            holidays: holidaysChecked,
            description: values?.aboutStore,
            address: values?.address,
            latitude: values?.latitude,
            longitude: values?.longitude,
            review_url: "",
            amenities: checkedValues,
            launch_date : formatDate( new Date (values?.launchDate)) ,
            banner_url:values?.signedBannerImg, 
            thumbnail_url: values?.signedthumbnailImg,
            image_url: values?.signedDisplayImg,
            is_published: 1,
            phone_number: values?.phoneNumber,
            email: values?.email
        }

        const res = storeId != undefined ? await updateStoreDetails(`store`, reqBody) : await createStoreDetails(`store`, reqBody)
        if (res?.success) {
            setDisableSubmit(false)
            showToast(1, res?.message)
            history.push({
                pathname: "/admin/storeManagement",
                state: {
                    isPublished: 1
                }
            })
        } else {
            console.log("resmessage", res?.message)
            setDisableSubmit(false)
        }
    }

    const AddStoreInDraftApi = async (values) => {
        setDisableDraft(true)
        setIsLoader(true)
        const reqBody = {
            id: storeId != undefined ? storeId : "",
            type: values?.storeCategory || storeDetails?.type,
            state: values?.state || storeDetails?.state,
            city: values?.city || storeDetails?.city,
            store_name: values?.storeName.trimEnd(),
            open_time: values?.openTime,
            close_time: values?.closeTime,
            holidays: holidaysChecked,
            description: values?.aboutStore,
            address: values?.address,
            latitude: values?.latitude,
            longitude: values?.longitude,
            review_url: "",
            amenities: checkedValues,
            launch_date : values?.launchDate !== "" ? formatDate( new Date (values?.launchDate)) :  formatDate( new Date()),
            banner_url:values?.signedBannerImg, 
            thumbnail_url: values?.signedthumbnailImg,
            image_url: values?.signedDisplayImg,
            is_published: 0,
            phone_number: values?.phoneNumber,
            email: values?.email
        }
        const res = storeId != undefined ? await updateStoreDetails(`store`, reqBody) : await createStoreDetails(`store`, reqBody)
        if (res?.success) {
            showToast(1, res?.message)
            setDisableDraft(false)
            history.push({
                pathname: "/admin/storeManagement",
                state: {
                    isPublished: 0
                }
            })
        } else {
            console.log("resmessage", res?.message)
            setDisableDraft(false)
        }
    }

    //function to validate the required fields 
    const validate = values => {
        if (values.isPublished === 1) {
            const errors = {};
            if (!values.storeCategory) {
                errors.storeCategory = "Required"
            }
            else if (!values.state) {
                errors.state = 'State Required';
            } else if (!values.city) {
                errors.city = 'City Required';
            }
            else if (!values.storeName) {
                errors.storeName = "Store Name Required"
            }
            else if (!values.phoneNumber) {
                errors.phoneNumber = 'Phone Number Required'
            } else if (values.phoneNumber.length != 10) {
                errors.phoneNumber = 'Invalid Number'
            }
            else if (!values.email) {
                errors.email = 'Email Required';
            } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
                errors.email = 'Invalid email address';
            } else if (!values.openTime) {

                errors.openTime = "Required"
            } else if (!values.closeTime) {
                errors.closeTime = "Required"
            }else if (!values.launchDate) {
                errors.launchDate = "Required"
            }
            else if (isPastDate(values.launchDate)) {
                errors.launchDate = "Please enter present date or upcoming date"
            }
            else if (values.bannerImg.length === 0 && isFutureDate(values.launchDate) ) {
                errors.bannerImg = "Please upload the banner image"
            }
            else if (!values.aboutStore) {
                errors.aboutStore = "Required"
            }
            else if (values.aboutStore.length < 200 ) {
                errors.aboutStore = 'Please enter min 200 characters'
            }
            else if (!values.address) {
                errors.address = 'Address 1 Required'
            } else if (values.address.length < 3) {
                errors.address = "Please enter min 3 characters"
            } else if (!values.latitude || !values.longitude) {
                errors.latitude = "Please add store location on maps"
            }
            else if (!values.amenitieschecked) {
                errors.amenitieschecked = "Amenities Required"
            }
            else if (values.amenitieschecked.length < 4) {
                errors.amenitieschecked = "Please enter minimum 4 aminities"
            }
            else if (values.amenitieschecked.length > 10) {
                errors.amenitieschecked = "Maximum 10 aminities can be entered"
            }
            else if (values.thumbnailImg.length === 0) {
                errors.thumbnailImg = "Please upload the  image"
            }
            else if (values?.signedDisplayImg.length < 6) {

                errors.displayImg = "Please upload exactly six images"
            }
            return errors;
        } else {
            const errors = {};
            if (!values.storeCategory) {
                errors.storeCategory = "Required"
            }
            else if (!values.state) {
                errors.state = 'State Required';
            } else if (!values.city) {
                errors.city = 'City Required';
            }
            else if (!values.storeName) {
                errors.storeName = "Store Name Required"
            }
            else if (!values.phoneNumber) {
                errors.phoneNumber = "Phone Number Required"
            }
            else if (values.phoneNumber.length != 10) {
                errors.phoneNumber = 'Invalid Number'
            }
            return errors;
        }
    };

    const formik = useFormik({
        initialValues: initialValues,
        validate,
        onSubmit: values => {
            {
                values?.isPublished === 1 ?
                    handleAddStoreApi(values) :
                    AddStoreInDraftApi(values)
            }

        },
    });

    const handleCityApi = () => {
        callCitylistApi()
        formik.setValues(prevValues => ({
            ...prevValues,
            city: "",
        }));
    }

    const thumbnailImageClose = () => {
        formik.setValues(prevValues => ({
            ...prevValues,
            thumbnailImg: [],
        }));
    }

    const bannerImageClose = () => {
        formik.setValues(prevValues => ({
            ...prevValues,
            bannerImg: [],
        }));
    }

    const handleBannerImage = async (data, fileInfo) => {
        let size = fileInfo.fileSize
        if (size > 5 * 1048576) {
            setBannerErrorMessage("Size should not execed more than 5 mb")
        } else if (size < 5 * 1048576 ) {
            setBannerErrorMessage("")
            formik.setValues(prevValues => ({
                ...prevValues,
                bannerImg: data?.name,
            }));
            const reqBody = {
                fileName: data?.name,
                mediaType: data?.type,
                dataType: "stores",
                serviceType: "thumbnail-image"
            };

            const resUrl = await getPresignedUrl("dataSignUrl", reqBody)
            if (resUrl?.success) {
                ImageUtils.uploadFileToS3(data, true, resUrl?.data?.preSignedUrl)
                    .then(res => {
                        if (res?.ok) {
                            formik.setValues(prevValues => ({
                                ...prevValues,
                                signedBannerImg: resUrl?.data.dataUrl,
                            }));
                        }
                        setBannerViewImg(resUrl?.data.dataUrl)
                    })
                    .catch(e => {
                        console.log(e);
                    });
                console.log("res", resUrl?.message)
            } else {
                console.log("res", resUrl?.message)
            }
        }
    }


    //function to call handle image upload 
    const handleImageUpload = async (data, fileInfo) => {
        let size = fileInfo.fileSize
        if (size > 5 * 1048576) {
            setErrorMessage("Size should not execed more than 5 mb")
        } else if (size < 5 * 1048576 ) {
            setErrorMessage("")
            formik.setValues(prevValues => ({
                ...prevValues,
                thumbnailImg: data?.name,
            }));
            const reqBody = {
                fileName: data?.name,
                mediaType: data?.type,
                dataType: "stores",
                serviceType: "thumbnail-image"
            };

            const resUrl = await getPresignedUrl("dataSignUrl", reqBody)
            if (resUrl?.success) {
                ImageUtils.uploadFileToS3(data, true, resUrl?.data?.preSignedUrl)
                    .then(res => {
                        if (res?.ok) {
                            formik.setValues(prevValues => ({
                                ...prevValues,
                                signedthumbnailImg: resUrl?.data.dataUrl,
                            }));
                        }
                        setPreviewImg(resUrl?.data.dataUrl)
                    })
                    .catch(e => {
                        console.log(e);
                    });
                console.log("res", resUrl?.message)
            } else {
                console.log("res", resUrl?.message)
            }
        }
    }

    const handleDisplayImageUpload = async (data, fileinfo) => {
        let size = fileinfo.fileSize
        if (size > 5 * 1048576) {
            showToast(3, "Image size should not be more than 5 mb")
        }
     else if (size < 5 * 1048576 ) {
            const reqBody = {
                fileName: data?.name,
                mediaType: data?.type,
                dataType: "stores",
                serviceType: "display-image"
            };
            const resUrl = await getPresignedUrl("dataSignUrl", reqBody)
            if (resUrl?.success) {
                ImageUtils.uploadFileToS3(data, true, resUrl?.data?.preSignedUrl)
                    .then(res => {
                        const obj = {
                            name: data?.name,
                            img: resUrl?.data.dataUrl
                        }
                        formik.setValues(prevValues => ({
                            ...prevValues,
                            displayImg: [...displayedArrayImages, resUrl?.data.dataUrl],
                        }))
                        formik.setValues(prevValues => ({
                            ...prevValues,
                            signedDisplayImg: [...displayedArrayImages, resUrl?.data.dataUrl],
                        }));
                        setDisplayedArrayImages([...displayedArrayImages, resUrl?.data.dataUrl])
                    })
                    .catch(e => {
                        console.log(e);
                    });
                console.log("res", resUrl?.message)
            } else {
                console.log("res", resUrl?.message)
            }
        } else {
            console.log("size, execed")
        }
    }

    const handleImageClose = (data, index) => {
        let imageArray = [...formik.values.displayImg.img || []]
        imageArray = displayedArrayImages.filter((data, i) => i !== index);
        formik.setValues(prevValues => ({
            ...prevValues,
            displayImg: [...imageArray],
        }))
        formik.setValues(prevValues => ({
            ...prevValues,
            signedDisplayImg: [...imageArray],
        }));
        setDisplayedArrayImages(imageArray)
    }

    const handleClickSubmit = async (e) => {
        handleKeyDown(e)
        await formik.setValues(prevValues => ({
            ...prevValues,
            isPublished: 1,
        }));
        formik.handleSubmit()
    }

    const handleOnclickDraft = async (e) => {
        handleKeyDown(e)
        await formik.setValues(prevValues => ({
            ...prevValues,
            isPublished: 0,
        }));
        formik.handleSubmit()
    }

    return (
        <div class="col-lg-12 " >
            {isLoader ? <Loader/> : null}
            <div class="col-lg-12  d-flex flex-column justify-content-center">
                <div class="d-flex w-100 flex-row justify-content-between align-items-center  border-bottom p-2">
                    <h1 class="fs-4 Montserrat fw-bold mx-4">
                        Add Store Details
                    </h1>
                </div>
                <div class="d-flex justify-content-center" >
                    <form onKeyDown={handleKeyDown} autoComplete="off" class="w-75 align-self-center">
                        <div class="d-flex col-lg-12 justify-content-around  my-2 flex-wrap">
                            <div class="col-md-5 mx-1 my-2">
                                <div class="d-flex ">
                                    <label class="fw-normal">
                                        Store Category *
                                    </label>
                                </div>
                                <CustomDropdown data={servicesData}
                                    value={formik.values.storeCategory}
                                    defaultValue={storeDetails?.service_name}
                                    onChange={(e) => {
                                        handleStoreCategory(e)
                                    }}
                                    error={formik.touched.storeCategory && Boolean(formik.errors.storeCategory)}
                                    helperText={formik.touched.storeCategory ? formik.errors.storeCategory : ''}
                                    name="Store"
                                    height={"44px"}
                                    placeholder="Store"
                                />
                            </div>
                            <div class="col-md-5 mx-1 my-2">
                                <div class="d-flex ">
                                    <label class="fw-normal">
                                        State *
                                    </label>
                                </div>
                                <CustomDropdown data={statesData}
                                    onChange={(e) => {
                                        handleStateChange(e)
                                    }}
                                    error={formik.touched.state && Boolean(formik.errors.state)}
                                    helperText={formik.touched.state ? formik.errors.state : ''}
                                    value={formik.values.state}
                                    defaultValue={storeDetails?.state_name}
                                    name="state"
                                    height={"44px"}
                                    placeholder="State"
                                />
                            </div>
                            <div class="col-md-5 mx-1  my-2">
                                <div class="d-flex ">
                                    <label class="fw-normal">
                                        City *
                                    </label>
                                </div>
                                <CustomDropdown data={cityData}
                                    onChange={(e) => {
                                        handleCityChange(e)
                                    }}
                                    error={formik.touched.city && Boolean(formik.errors.city)}
                                    helperText={formik.touched.city ? formik.errors.city : ''}
                                    value={formik.values?.city}
                                    defaultValue={storeDetails?.city_name}
                                    name="city"
                                    height={"44px"}
                                    callApi={handleCityApi}
                                    stateId={stateId}
                                />
                            </div>
                            <div class="col-md-5 mx-1  my-2">
                                <CustomTextField
                                    control={control}
                                    header={"Store Name *"}
                                    name="Store Name"
                                    size="small"
                                    value={formik.values.storeName.trimStart()}
                                    placeholder={"Store Name"}
                                    inputProps={{
                                        min: 3,
                                        maxLength: 30,
                                        style: {
                                            height: "28px",
                                        }
                                    }}
                                    error={formik.touched.storeName && Boolean(formik.errors.storeName)}
                                    helperText={formik.touched.storeName ? formik.errors.storeName : ''}
                                    InputProps={{ sx: { borderRadius: "12px" } }}
                                    onChange={(e) => {
                                        handleStoreName(e)
                                    }}
                                />
                            </div>
                            <div class="col-md-5 mx-1  my-2">
                                <CustomTextField
                                    control={control}
                                    header={"Phone number *"}
                                    type={"tel"}
                                    name="Phone number"
                                    size="small"
                                    value={formik.values.phoneNumber.trimStart()}
                                    placeholder={"Phone number"}
                                    inputProps={{
                                        min: 10,
                                        maxLength: 10, style: {
                                            height: "28px",
                                        }
                                    }}
                                    error={formik.touched.phoneNumber && Boolean(formik.errors.phoneNumber)}
                                    helperText={formik.touched.phoneNumber ? formik.errors.phoneNumber : ''}
                                    InputProps={{ sx: { borderRadius: "12px" } }}
                                    onChange={(e) => {
                                        const result = e.replace(/[^0-9]/g, '');
                                        handleNumberChange(result)
                                    }}
                                />
                            </div>
                            <div class="col-md-5 mx-1  my-2">
                                <CustomTextField
                                    control={control}
                                    header={"Email *"}
                                    name="email"
                                    size="small"
                                    value={formik.values.email.trimStart()}
                                    placeholder={"Email"}
                                    inputProps={{
                                        min: 3,
                                        maxLength: 50, style: {
                                            height: "28px",
                                        }
                                    }}
                                    error={formik.touched.email && Boolean(formik.errors.email)}
                                    helperText={formik.touched.email ? formik.errors.email : ''}
                                    InputProps={{ sx: { borderRadius: "12px" } }}
                                    onChange={(e) => {
                                        handleEmailChange(e)
                                    }}
                                />
                            </div>
                            <div class="col-md-5 mx-1  my-2">
                                <div class="roboto  ">
                                    <h6 class="paraColor m-0 fw-normal">Open Time *</h6>
                                </div>
                                <div>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopTimePicker
                                            sx={{ width: "100%", height: "50px", borderRadius: "1.75em" }}
                                            className="custom-timepicker"
                                           slotProps={{
                                            textField: {
                                              sx: {
                                                borderRadius: 6,
                                                width: "100%",    
                                                fieldset: { borderRadius: "0.75em" ,error: false,height:"50px"},
                                              '& .MuiInputLabel-root': { lineHeight: 3 },
                                             },
                                             error: false,
                                             size: "small"
                                            },
                                          }}
                                            value={dayjs(`${formik?.values?.openTime}`)}
                                            onChange={(e) => {
                                                handleOpenTime(e)
                                            }}
                                        />  
                                    </LocalizationProvider>
                                </div>
                                <div class="d-flex align-self-center m-0">
                                    {formik.touched.openTime && formik.errors.openTime && (
                                        <h6 class="text-danger ">{formik.errors.openTime}</h6>
                                    )}
                                </div>
                            </div>

                            <div class="col-md-5 mx-1  my-2">
                                <div class="roboto ">
                                    <h6 class="paraColor m-0 fw-normal">Close Time *</h6>
                                </div>
                                <div>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopTimePicker
                                            // sx={{ width: "100% ", borderRadius: "12px" }}
                                           slotProps={{
                                            textField: {
                                              sx: {
                                                borderRadius: 6,
                                                width: "100%",    
                                                fieldset: { borderRadius: "0.75em",error: false,height:"50px"},
                                              '& .MuiInputLabel-root': { lineHeight: 3 },
                                             },
                                             error: false,
                                             size: "small"
                                            },
                                          }}
                                            value={dayjs(`${formik?.values?.closeTime}`)}
                                            onChange={(e) => {
                                                handleCloseTime(e)
                                            }}
                                        />
                                    </LocalizationProvider>
                                </div>
                                <div class="d-flex align-self-center m-0">
                                    {formik.touched.closeTime && formik.errors.closeTime && (
                                        <h6 class="text-danger ">{formik.errors.closeTime}</h6>
                                    )}
                                </div>
                            </div>

                            <div class="col-md-5 mx-1 my-2 mb-0">
                            <div class="roboto  ">
                                    <h6 class="paraColor m-0 fw-normal">Launch Date*</h6>
                                </div>
                                <div>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                        sx={{ width: "100%", height: "50px", borderRadius: "1.75em" }}
                                        className="custom-timepicker"
                                        format="DD-MM-YYYY"
                                        disablePast={true}
                                       slotProps={{
                                        textField: {
                                          sx: {
                                            borderRadius: 6,
                                            width: "100%",    
                                            fieldset: { borderRadius: "0.75em" ,error: false,height:"50px"},
                                          '& .MuiInputLabel-root': { lineHeight: 3 },
                                         },
                                         error: false,
                                         size: "small"
                                        },
                                      }}
                                      value={dayjs(`${formik?.values?.launchDate}`)}
                                      onChange={(e) => {
                                        handleLaunchTime(e)
                                    }}
                                        /> 
                                    </LocalizationProvider>
                                </div>
                                <div class="d-flex align-self-center m-0">
                                    {formik.touched.launchDate && formik.errors.launchDate && (
                                        <h6 class="text-danger ">{formik.errors.launchDate}</h6>
                                    )}
                                </div>    
                                </div>

                                <div class="d-flex col-md-5 mx-1  align-slef-start align-items-center">
                                <div class="w-75 ">
                                    <CustomTextField
                                        control={control}
                                        header={"Banner Image *"}
                                        name="Banner Image"
                                        size="small"
                                        value={formik.values.bannerImg}
                                        placeholder={"Banner Image"}
                                        inputProps={{
                                            min: 3,
                                            maxLength: 250,
                                            style: {
                                                height: "28px",
                                                opacity: 2
                                            },
                                            color: "#3E4958"
                                        }}
                                        error={formik.touched.bannerImg && Boolean(formik.errors.bannerImg)}
                                        helperText={formik.touched.bannerImg ? formik.errors.bannerImg : ''}
                                        InputProps={{ sx: { borderRadius: "12px" } }}
                                        disabled={true}
                                    />
                                </div>
                            
                                <div class={`d-flex justify-content-center align-items-center p-2  ${formik.touched.bannerImg && Boolean(formik.errors.bannerImg) ? `mt-1` : 'mt-4'} `}>
                                    {formik.values.bannerImg.length === 0 ?
                                        <FileUpload onClick={handleBannerImage} from={"imgInput1"} id={"img3"} name={"img3"} /> :
                                        null
                                    }
                                </div>
                                {
                                    formik.values.bannerImg.length != 0 ?
                                        <div class="shadow m-2  ">
                                            <div class="d-flex flex-column ">
                                                <i class="bi bi-x align-self-end" onClick={() => bannerImageClose()} ></i>
                                                <img onClick={() => handleBannerPreview(bannerViewImg)} src={bannerViewImg || formik.values.bannerImg} class="imageBoxCss" alt="banner_img" />
                                            </div>
                                        </div> : null
                                }
                            </div>
                            <div class="d-flex justify-content-end col-md-11">
                                <div class="col-md-6 ms-5 text-center">
                                {
                                    errorBannerMessage !== "" ? <h6 class="text-danger me-xxl-4">{errorBannerMessage}</h6> : <h6 class="text-danger me-xxl-4">{errorBannerMessage}</h6>
                                }
                                </div>
                               
                            </div>
                            <div class="d-flex flex-column col-md-11 mx-1 my-2 shadow  ">
                                <div class="roboto mx-2 my-2 p-2 ">
                                    <h6 class="paraColor fw-normal">Holidays </h6>
                                </div>
                                <div class="d-flex my-3 mx-2 justify-content-around  ">
                                    {
                                        holidaysData.map((data,index) => {
                                            return (
                                                <div class="d-flex" key={index}>
                                                    <div class="d-flex flex-row" >
                                                        <div class="text-center"  >
                                                            <input type="checkbox" class="my-2 mx-2" onChange={(e) => handleHolidayCheckbox(e, data?.day)} checked={holidaysChecked != undefined ? holidaysChecked.includes(data.day.toString()) : false} />
                                                        </div>
                                                        <h6 class="m-0 my-1">{data?.day}</h6>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>

                                <div class="d-flex align-self-center m-0">
                                    {formik.touched.holiday && formik.errors.holiday && (
                                        <h6 class="text-danger ">{formik.errors.holiday}</h6>
                                    )}
                                </div>
                            </div>
                          
                            <div class="col-md-11 mx-1  my-2">
                                <CustomTextField
                                    control={control}
                                    header={"About Store *"}
                                    name="About Store"
                                    size="small"
                                    value={formik.values.aboutStore.trimStart()}
                                    placeholder={"Add message"}
                                    inputProps={{
                                        min: 200,
                                        maxLength: 500,
                                    }}
                                    multiline={true}
                                    rows={6}
                                    error={formik.touched.aboutStore && Boolean(formik.errors.aboutStore)}
                                    helperText={formik.touched.aboutStore ? formik.errors.aboutStore : ''}
                                    InputProps={{ sx: { borderRadius: "12px" } }}
                                    onChange={(e) => {
                                        const result = e.replace(/"/g, '');
                                        
                                        handleAboutStoreChange(result)
                                    }}
                                />
                            </div>
                            <div class="col-md-5 mx-1  my-2">
                                <CustomTextField
                                    control={control}
                                    header={"Address *"}
                                    name="Address"
                                    size="small"
                                    value={formik.values.address.trimStart()}
                                    placeholder={"Address"}
                                    inputProps={{
                                        min: 3,
                                        maxLength: 250,
                                    }}
                                    multiline={true}
                                    rows={5}
                                    error={formik.touched.address && Boolean(formik.errors.address)}
                                    helperText={formik.touched.address ? formik.errors.address : ''}
                                    InputProps={{ sx: { borderRadius: "12px" } }}
                                    onChange={(e) => {
                                        handleOnchangeAddress(e)
                                    }}
                                />
                            </div>

                            <div id="map" style={{ width: '40%', height: '300px' }}></div>
                            <div class="d-flex col-md-11  justify-content-end m-0">
                                {formik.touched.latitude && formik.errors.latitude && (
                                    <h6 class="text-danger ">{formik.errors.latitude}</h6>
                                )}
                            </div>
                            {/* <div class="col-md-11 mx-1  my-2">
                                <CustomTextField
                                    control={control}
                                    header={"Google Reviews"}
                                    name="Google Reviews"
                                    size="small"
                                    value={formik.values.googleReviewLink}
                                    placeholder={"Google reviews"}
                                    inputProps={{
                                        min: 3,
                                        maxLength: 250,
                                        style: {
                                            height: "28px",
                                        }
                                    }}
                                    error={formik.touched.googleReviewLink && Boolean(formik.errors.googleReviewLink)}
                                    helperText={formik.touched.googleReviewLink ? formik.errors.googleReviewLink : ''}
                                    InputProps={{ sx: { borderRadius: "12px" } }}
                                    onChange={(e) => {
                                        handleGoogleReviewLink(e)
                                    }}
                                />
                            </div> */}
                            <div class="d-flex flex-column col-md-11 mx-1 my-3 shadow   ">
                                <div class="roboto mx-2 my-2 p-2 ">
                                    <h6 class="paraColor fw-normal">Store Amenities *</h6>
                                </div>
                                <div class="d-flex  my-3 mx-2  overflow-auto">
                                    {
                                        storeAmenitiesData.map((data,index) => {
                                            const iconstring = data?.icon
                                            return (
                                                <div class="amenitiesWidth" key={index}>
                                                    <div class="d-flex  flex-column mx-2" >
                                                        <div class="my-2 text-center">
                                                            <img src={data?.icon_url} alt="aminities_icon"/>
                                                        </div>
                                                        <div >
                                                            <h6 class="mx-2 my-1 text-center">{data?.name}</h6>
                                                        </div>
                                                        <div class="text-center"  >
                                                            <input type="checkbox" id={data.id} class="my-2" onChange={(e) => handleChangeCheckbox(e, data?.id)} checked={checkedValues !== undefined ? checkedValues.includes(data.id.toString()) : false} />
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                                <div class="d-flex align-self-center m-0">
                                    {formik.touched.amenitieschecked && formik.errors.amenitieschecked && (
                                        <h6 class="text-danger ">{formik.errors.amenitieschecked}</h6>
                                    )}
                                </div>
                            </div>
                            <div class="d-flex col-md-11 mx-1 my-1 align-slef-start align-items-center">
                                <div class="w-75">
                                    <CustomTextField
                                        control={control}
                                        header={"Thumbnail Image *"}
                                        name="Thumbnail Image"
                                        size="small"
                                        value={formik.values.thumbnailImg}
                                        placeholder={"Thumbnail Image"}
                                        inputProps={{
                                            min: 3,
                                            maxLength: 250,
                                            style: {
                                                height: "28px",
                                                opacity: 2
                                            },
                                            color: "#3E4958"
                                        }}
                                        error={formik.touched.thumbnailImg && Boolean(formik.errors.thumbnailImg)}
                                        helperText={formik.touched.thumbnailImg ? formik.errors.thumbnailImg : ''}
                                        InputProps={{ sx: { borderRadius: "12px" } }}
                                        disabled={true}
                                    />
                                </div>
                                <div class={`d-flex justify-content-center align-items-center p-2  ${formik.touched.thumbnailImg && Boolean(formik.errors.thumbnailImg) ? `mt-1` : 'mt-4'} `}>
                                    {formik.values.thumbnailImg.length === 0 ?
                                        <FileUpload onClick={handleImageUpload} from={"imgInput1"} id={"img1"} name={"img1"} /> :
                                        null
                                    }
                                </div>
                                {
                                    formik.values.thumbnailImg.length != 0 ?
                                        <div class="shadow m-2 mt-4 ">
                                            <div class="d-flex flex-column ">
                                                <i class="bi bi-x align-self-end" onClick={() => thumbnailImageClose()} ></i>
                                                <img onClick={() => handlePreviewImg(previewImg || formik.values.thumbnailImg)} src={previewImg || formik.values.thumbnailImg} class="imageBoxCss" alt="thumbnail_img" />
                                            </div>
                                        </div> : null
                                }
                            </div>
                            <div class="d-flex col-md-11">
                                {
                                    errorMessage !== "" ? <h6 class="text-danger">{errorMessage}</h6> : <h6 class="text-danger">{errorMessage}</h6>
                                }
                            </div>
                            <div class="d-flex col-md-11 mx-1 my-1 align-self-start align-items-center">
                                <div class="w-75 ">
                                    <CustomTextField
                                        control={control}
                                        header={"Display Image *"}
                                        name="Display Image"
                                        size="small"
                                        value={"Please upload six images of store "}
                                        placeholder={"Please upload six images of store"}
                                        inputProps={{
                                            min: 3,
                                            maxLength: 250,
                                            style: {
                                                height: "28px",
                                                opacity: 2
                                            },

                                            color: "#3E4958"
                                        }}
                                        error={formik.touched.displayImg && Boolean(formik.errors.displayImg)}
                                        helperText={formik.touched.displayImg ? formik.errors.displayImg : ''}
                                        InputProps={{ sx: { borderRadius: "12px" } }}
                                        disabled={true}
                                    />
                                </div>
                                {
                                    displayedArrayImages.length !== 6 ?
                                        <div class={`d-flex justify-content-center align-items-center p-2  ${formik.touched.displayImg && Boolean(formik.errors.displayImg) ? `mt-1` : 'mt-4'} `}>
                                            <FileUpload onClick={handleDisplayImageUpload} id={"img2"} name={"img2"} from={"imgInput2"} />
                                            <div>
                                            <span data-bs-toggle="tooltip" data-bs-placement="top" title={"For better looking image please upload image in range of 400 x 190"} class="ms-3" ><i class="bi bi-exclamation-circle cursorPointer"></i></span>
                                            </div>
                                        </div>
                                        :
                                        null
                                }
                            </div>
                            {
                             displayedArrayImages !== "" ?
                                <div class="d-flex col-md-11 mx-1 flex-wrap justify-content-start  ">{
                                    displayedArrayImages.map((data, index) => {
                                        return (
                                            <div class="shadow m-2 ">
                                                <div class="d-flex flex-column ">
                                                    <i class="bi bi-x align-self-end" onClick={() => handleImageClose(data, index)} ></i>
                                                    <img onClick={() => handlePreviewImg(data)} src={data} class="imageBoxCss" alt="display_img" />
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                                </div> :
                                null
                            }
                            <CustomModal
                                close={handleClose}
                                open={show}
                                imgvalue={previewImg}
                            />
                            <CustomModal
                                close={handleBannerClose}
                                open={bannerShow}
                                imgvalue={bannerViewImg}
                            />
                            {console.log("store",storeDetails,isPublished)}
                            {
                                storeDetails === undefined  || isPublished !== 1?
                                    <div class="d-flex  justify-content-center align-items-center my-4">
                                        <div class="my-2 align-self-center mx-4">
                                            <button type="button" onClick={(e) => handleClickSubmit(e)} variant="contained" class="primaryButton px-3" disabled={disableSubmit}>
                                                Submit
                                            </button>
                                        </div>
                                        <div class="my-2 align-self-center mx-4">
                                            <button type="button" onKeyDown={handleKeyDown} onClick={(e) => handleOnclickDraft(e)} variant="contained" class="primaryButton px-4" disabled={disableDraft} >
                                                Draft
                                            </button>
                                        </div>
                                    </div>
                                    :
                                    <div class="d-flex  justify-content-center align-items-center my-4">
                                                <div class="my-2 align-self-center mx-3">
                                                    <button type="button" onClick={(e) => handleClickSubmit(e)} variant="contained" class="primaryButton px-3" disabled={disableSubmit}>
                                                        Submit
                                                    </button>
                                                </div> 
                                    </div>
                            }
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}
export default AddStoresForms
